import React from "react";
import Utilities from "@util/Utilities";
import {StarIcon} from "@heroicons/react/20/solid";
import _uniqueId from "lodash/uniqueId";
import Hotel from '@app/model/hotel/Hotel';
import HotelRatingType from '@app/model/hotel/HotelRatingType';

type Props = {
    rating: number,
    ratingType?: HotelRatingType
}

const Rating: React.FunctionComponent<Props> = ({rating, ratingType = HotelRatingType.STARS}) => {

    const Icon = ratingType === HotelRatingType.STARS ? <StarIcon className="" aria-hidden="true" /> :
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
           fill="currentColor"
           aria-hidden="true" data-slot="icon"
           className="w-4 h-auto">
          <path fillRule="evenodd"
                d="M8 7a5 5 0 1 1 3.61 4.804l-1.903 1.903A1 1 0 0 1 9 14H8v1a1 1 0 0 1-1 1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L8.196 8.39A5.002 5.002 0 0 1 8 7Zm5-3a.75.75 0 0 0 0 1.5A1.5 1.5 0 0 1 14.5 7 .75.75 0 0 0 16 7a3 3 0 0 0-3-3Z"
                clipRule="evenodd"></path>
      </svg>

    const color = ratingType === HotelRatingType.STARS ? "text-yellow-400" : "text-orange-400"

    return <div className="flex items-center text-sm text-gray-500">
        {Array.apply(0, Array(5))
          .map((x: any, i: number) =>
            <div key={_uniqueId("rating_") + "_" + i}
                 className={Utilities.classNames((i <= rating - 1) ? color : "text-gray-200", "w-4 h-auto")}>
                {Icon}
            </div>
          )}
    </div>
}

export default Rating